import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Redirect } from 'react-router';
import { useCookies } from 'react-cookie';
import { Spinner } from 'reactstrap';
import { fetchProfile } from '@/store/auth/authActions';
import { ACCESS_TOKEN, ADMIN_ROLE, PSYCHOLOGIST_ROLE } from '@/configs';
import { ROUTES } from '@/configs/routesConfig';

const PrivateRoute = (props) => {
  const { path, children, role, redirect } = props;
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [cookies] = useCookies([ACCESS_TOKEN]);
  const token = cookies[ACCESS_TOKEN];

  useEffect(() => {
    if (!auth.isLoaded && token) {
      dispatch(fetchProfile());
    }
  }, []);

  if (!token && auth.isLoaded) {
    return <Redirect to={{ pathname: ROUTES.login, search: '?logout=true' }} />;
  }

  if ((auth.isLoaded && !auth.is_staff) || (!token && path === '/')) {
    return <Redirect to={{ pathname: ROUTES.login }} />;
  }

  if (auth.user_role && path === '/') {
    const specialistStartRoute = auth?.nutritionist && !auth?.psychologist
      ? ROUTES.nutritionConsultations
      : ROUTES.consultations;
    const redirectUrlMap = {
      [ADMIN_ROLE]: ROUTES.psychologists,
      [PSYCHOLOGIST_ROLE]: specialistStartRoute,
    }
    return <Redirect to={{ pathname: redirectUrlMap[auth.user_role] || ROUTES.login }} />;
  }

  if (auth.user_role && auth.user_role !== role) {
    return <Redirect to={{ pathname: redirect }} />;
  }

  return (
    <>
      {!auth.isLoaded ? (
        <Spinner color="primary" type="grow" />
      ) : (
        <Route
          path={path}
          render={(props) =>
            auth.isAuth ? (
              children
            ) : (
              <Redirect
                to={{ pathname: ROUTES.login, state: { from: props.location } }}
              />
            )
          }
        />
      )}
    </>
  );
};

PrivateRoute.defaultProps = {
  role: null,
};

export default PrivateRoute;
